<script lang="ts" setup>
    import { ref } from 'vue';
    import Camera from "@/components/Camera.vue";

    const camera = ref<InstanceType<typeof Camera>>();
    const props = defineProps<{
        modelValue: number | string | boolean | undefined | 'Yes' | 'No',
        min: number | undefined,
        max: number | undefined,
        options: string[] | string | undefined,
        id: string
    }>();
    const emit = defineEmits(["update", "next"]);
    const image = ref<string | null>(null);
    const wasSkipped = ref(false)

    const skip = () => {
        wasSkipped.value = true;
        emit('update')
    }
    const load = (value: string | number | boolean | undefined) => {
        if (value != undefined) {
            image.value = value.toString();
        }
        camera.value!.start();
    }

    const validate = () :  'under' | 'over' | 'invalid' | 'ok' | 'ignore' => {
        if (wasSkipped.value) return "ignore";
        if (image.value == null) return "invalid";
        return 'ok';
    }
    const value = () => {
        if (wasSkipped.value) return "Skipped";
        return image.value;
    }
    const snapshot = async (blob: Blob) => {
        if (blob != undefined) {
            var reader = new FileReader();
            reader.readAsDataURL(blob); 
            reader.onloadend = function() {
                var base64data = reader.result; 
                image.value = base64data?.toString()!;
            }
        }
    }
    const retake = () => {
        image.value = null;
        camera.value?.start();
    }

    defineExpose({ validate, load, value, skip });
</script>

<template>
    <div v-show="image == null">
        <Camera ref="camera" @snapshot="snapshot"></Camera>
    </div>
    <div class="text-centered" v-if="image != null">
        <img :src="image" :style="{maxWidth: '100%'}"  />
        <button class="retake" @click="retake">
            <i class="fas fa-repeat"></i>
            Retake
        </button>
    </div>
</template>

<style scoped>
    .text-centered{
        text-align: center;
        position:relative;
    }
    .retake{
        position: absolute;
        bottom: 30px;
        left: 50%;
        width: 100px;
        margin-left: -45px;
        background: #fff;
        border: 1px solid #000;
        padding: 10px;
        font-size: 1.3em;
        border-radius: 50%;
        height: 90px;
        width: 90px;
    }
</style>